import { useEffect, useRef, useState } from "react";
import { DEFAULT_DESIGN_STUDIO_VIDEO, normalizeIntroVideo, type DesignStudioIntroVideo } from "../../config/blissDesignStudioSlideshow";

/** Uses the same owner-managed introductory video as the original Quick Start. */
export default function TransformationIntroVideo() {
  const [video, setVideo] = useState<DesignStudioIntroVideo | null>(DEFAULT_DESIGN_STUDIO_VIDEO);
  const completedPlays = useRef(0);
  const [showControls,setShowControls]=useState(false);
  useEffect(() => { completedPlays.current = 0; setShowControls(false); }, [video?.url]);
  useEffect(() => {
    const controller = new AbortController();
    void fetch("/api/design-studio-slideshow", { signal: controller.signal })
      .then(response => response.ok ? response.json() : null)
      .then(settings => {
        if (!settings || controller.signal.aborted) return;
        setVideo(settings.introVideo === null ? null : normalizeIntroVideo(settings.introVideo) ?? DEFAULT_DESIGN_STUDIO_VIDEO);
      }).catch(() => {});
    return () => controller.abort();
  }, []);
  if (!video) return null;
  return <figure className="bcj-transformation-video">
    <video key={video.url} src={video.url} poster={video.posterUrl} onEnded={event => {
      if (completedPlays.current >= 10) {setShowControls(true);return;}
      completedPlays.current += 1;
      const player = event.currentTarget;
      player.currentTime = 0;
      void player.play().catch(() => setShowControls(true));
    }} controls={showControls} autoPlay muted playsInline preload="metadata" aria-label="See your room transformation — introductory video" />
  </figure>;
}

